import React, { createContext, useContext, useEffect, useState } from "react";
import { useValidateLogin } from "./api/setting.api";
import { notification } from "antd";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

    const [ company, setCompany ] = useState(JSON.parse(sessionStorage?.getItem('cirrus-company') || null));
    const [ loginRole, setLoginRole ] = useState(JSON.parse(sessionStorage?.getItem('cirrus-role') || null));
    const [ loginUser, setLoginUser ] = useState(JSON.parse(sessionStorage?.getItem('cirrus-user') || null));
    const [ token, setToken ] = useState(sessionStorage?.getItem('cirrus-token') || null);

    const [ selectedCargo, setSelectedCargo ] = useState(JSON.parse(sessionStorage?.getItem('cirrus-cargo') || null));
    const [ actualCargo, setActualCargo ] = useState(JSON.parse(sessionStorage?.getItem('cirrus-actual-cargo') || null));

    const { data: loginUserData, mutate: validateLogin, isSuccess, isError, error, isLoading } = useValidateLogin();

    const [ loginLoading, setLoginLoading ] = useState(false);

    useEffect(() => {

        if (isSuccess) {
            setLoginLoading(false);
            if (loginUserData?.data) {
                const loginData = loginUserData.data;

                if (['ACTIVE', 'NEW'].includes(loginData.user.userStatus)) {
                    notification.success({ "message": "Successfully logged in" });

                    sessionStorage.setItem('cirrus-company', JSON.stringify(loginData.company));
                    sessionStorage.setItem('cirrus-role', JSON.stringify(loginData.role));
                    sessionStorage.setItem('cirrus-user', JSON.stringify(loginData.user));
                    sessionStorage.setItem('cirrus-token', loginData.token);

                    setCompany(loginData.company);
                    setLoginRole(loginData.role);
                    setLoginUser(loginData.user);
                    setToken(loginData.token);
                } else {
                    notification.warning({ "message": "Cannot login, user not active..." })
                }
            } else {
                notification.error({ 'message': 'Login failed, 3 unsuccessful attempt will block your access, check credentials and try again...' });
                return;
            }
        }

        if (isError) {
            setLoginLoading(false);
            notification.error({ 'message': error.message || 'An error occurred' });
        }
    }, [isSuccess, loginUserData, isError, error]);

    const handleLoginUser = (payload) => {
        setLoginLoading(true);
        validateLogin(payload);
    }

    const handleLogoutUser = () => {

        setSelectedCargo(null);
        setCompany(null);
        setLoginRole(null);
        setLoginUser(null);
        setToken(null);
        setActualCargo(null);

        sessionStorage.removeItem('cirrus-company');
        sessionStorage.removeItem('cirrus-role');
        sessionStorage.removeItem('cirrus-user');
        sessionStorage.removeItem('cirrus-token');

        sessionStorage.removeItem('cirrus-cargo');
        sessionStorage.removeItem('cirrus-actual-cargo');

        window.location.replace("#/");
    }

    return (
        <AuthContext.Provider value={{
            handleLoginUser, handleLogoutUser, company, setCompany,
            loginRole, setLoginRole, loginUser, setLoginUser, token,
            selectedCargo, setSelectedCargo, actualCargo, setActualCargo,
            loginLoading
        }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuthContext = () => useContext(AuthContext);
